export const initialState = {
  toasts: [],
  isVisible: false,
};
